import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
// import "bootstrap/dist/js/bootstrap.bundle";
import "../../../node_modules/bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { baseUrl, getUserApi } from "api";
import { upload } from "@testing-library/user-event/dist/upload";
import { withTranslation } from "react-i18next";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      searchName: "",
      userList: [],
    };
  }

  async componentDidMount() {
    this.getUserList();
  }

  async getUserList(inputValue) {
    const data = await getUserApi({
      page: this.state.page,
      limit: this.state.sizePerPage,
      name: inputValue,
    });
    if(data && data.data){
      this.setState({
        totalSize: data.data.count,
        userList: data.data.users,
      });
    }
   
    return [
      { label: "All", value: "" },
      ...this.state.userList.map(x => {
        return {
          label: x.name,
          value: x.id,
        };
      }),
    ];
  }

  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getUserList(inputValue));
        }, 0);
      });
    const columns = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "name",
        text: `${this.props.t("Name")}`,
        formatter: (cell, row) => (
          <div className="d-flex flex-row">
            <div>
              {row.photo == null || row.photo == "null" ? (
                <img
                  src="images/dashboard-images/company.png"
                  className="width-50"
                />
              ) : (
                <img
                  src={`${baseUrl}/uploads/${row.photo}`}
                  className="width-50"
                />
              )}
            </div>
            <div className="ps-2 ">
              <p className="fw-bold fs-5 pt-2"> {row.name} </p>
            </div>
          </div>
        ),
      },
      {
        dataField: "role",
        text: `${this.props.t("Role")}`,
        formatter: (cell, row) => cell.name,
      },
      {
        dataField: "factory",
        text: `${this.props.t("Factory")}`,
        formatter: (cell, row) => cell.name,
      },
      {
        dataField: "mobileNo1",
        text: `${this.props.t("Mobile no.1")}`,
      },
      {
        dataField: "mobileNo2",
        text: `${this.props.t("Mobile no.2")}`,
      },
      {
        dataField: "email",
        text: `${this.props.t("Email")}`,
      },
      {
        dataField: "notes",
        text: `${this.props.t("Notes")}`,
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <Link
              to={{
                pathname: "/add-user",
                query: { isEdit: true, data: row },
              }}
            >
              {" "}
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
            <Link
              to={{
                pathname: "/add-user",
                query: { isView: true, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getUserList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getUserList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "add user";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.userList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.userList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                    {this.props.t("Manage User")}
                    </h3>
                    <Row>
                      <Col md="6" sm="12">
                        <div className="pt-4">
                          <p className="d-inline pe-3 fs-5">
                            {this.props.t("Show")}
                          </p>
                          <div className="d-inline">
                            <SizePerPageDropdownStandalone
                              className=""
                              {...paginationProps}
                            />
                          </div>

                          <p className="d-inline ps-3 fs-5">
                            {this.props.t("entries")}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl={{ offset: "3", size: "3" }}
                        xl={{ offset: "2", size: "4" }}
                        md={{ offset: "0", size: "6" }}
                        sm={{ offset: "0", size: "12" }}
                        className="text-start text-lg-end pt-4 pt-lg-0"
                      >
                        <div className="d-flex justify-content-end">
                          <div className="">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 text-end pe-lg-3 d-inline"
                            >{this.props.t("Search")}</label>
                          </div>
                          <AsyncSelect
                            onChange={e => {
                              if (e.value == "") {
                                this.getUserList(null);
                              } else {

                              this.getUserList(e.label);
                              }
                            }}
                            loadOptions={promiseOptions}
                            defaultOptions={[
                              { label: "All", value: "" },
                              ...this.state.userList.map(x => {
                                return { value: x.id, label: x.name };
                              }),
                            ]}
                            className="border-gray"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <CardTitle className="h4">
                              {this.props.t("User List ")}
                            </CardTitle>

                            <React.Fragment>
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex"></Col>
                              </Row>
                              <Row className="mb-2"></Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      remote={true}
                                      keyField={"id"}
                                      bordered={false}
                                      striped={false}
                                      onTableChange={() => false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                                <div className="">
                                  <h5>
                                    {this.props.t("Showing")}{" "}
                                    {(this.state.page - 1) *
                                      this.state.sizePerPage +
                                      1}{" "}
                                    -{" "}
                                    {this.state.totalSize <
                                    this.state.sizePerPage
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                          this.state.page >=
                                        this.state.totalSize
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                        this.state.page}{" "}
                                    of {this.state.totalSize}
                                  </h5>
                                </div>
                                <div className="ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(UserList);
